function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.599 1.49h26.218a2.273 2.273 0 012.28 2.276v48.925a2.273 2.273 0 01-2.28 2.276H15.599a2.273 2.273 0 01-2.28-2.276V3.766a2.273 2.273 0 012.28-2.275z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.739 8.317h23.938v37.547H16.739zM25.858 3.766h5.7c.631 0 1.14.508 1.14 1.138 0 .63-.509 1.138-1.14 1.138h-5.7c-.632 0-1.14-.508-1.14-1.138 0-.63.508-1.138 1.14-1.138zM30.988 50.302c0 1.257-1.02 2.276-2.28 2.276s-2.28-1.02-2.28-2.276 1.021-2.276 2.28-2.276 2.28 1.02 2.28 2.276z"
}));

var SvgCellphone = function SvgCellphone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCellphone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cell phone.d7d662b5.svg";
export { ForwardRef as ReactComponent };